module.exports = __webpack_public_path__ + "img/menu_visa_new.43585f86.png";